import {
  // type MotionValue,
  type PanInfo,
  useMotionValue,
} from 'framer-motion'
import { useCallback } from 'react'


import { useEffect } from 'react';
interface ResizeOptions {
  minWidth: number
  maxWidth: number
  /** 轨道总长度，用于约束右边界 */
  trackLength?: number
  onResize?: (offset: number, width: number) => void
}

const useResizeHandlers = (
  dragSliderDefaultWidth: number,
  options: ResizeOptions,
) => {
  const width = useMotionValue(dragSliderDefaultWidth)
  const x = useMotionValue(0)

  useEffect(() => {
    width.set(dragSliderDefaultWidth)
  }, [dragSliderDefaultWidth, width])

  const { minWidth, maxWidth, trackLength, onResize } = options

  const handleLeftResize = useCallback(
    (evt: PointerEvent, info: PanInfo) => {
      const deltaX = info.delta.x
      const currentWidth = width.get()
      const currentX = x.get()

      const newWidth = Math.round(
        Math.max(minWidth, Math.min(maxWidth, currentWidth - deltaX)),
      )
      let newX = Math.round(currentX + (currentWidth - newWidth))

      if (newX < 0) {
        newX = 0
        const widthDelta = currentX + currentWidth - newX
        width.set(widthDelta)
      } else {
        width.set(newWidth)
      }
      x.set(newX)

      onResize?.(newX, newWidth)
    },
    [minWidth, maxWidth, x, width, onResize],
  )

  const handleRightResize = useCallback(
    (evt: PointerEvent, info: PanInfo) => {
      const deltaX = info.delta.x
      const currentWidth = width.get()
      const currentX = x.get()
      // 限制右边界不超出轨道
      const maxAllowedWidth = trackLength
        ? Math.min(maxWidth, trackLength - currentX)
        : maxWidth
      const newWidth = Math.round(
        Math.min(maxAllowedWidth, Math.max(minWidth, currentWidth + deltaX)),
      )

      width.set(newWidth)

      onResize?.(currentX, newWidth)
    },
    [maxWidth, minWidth, trackLength, width, onResize, x],
  )

  return {
    dragOffset: x,
    dragSliderWidth: width,
    handleLeftResize,
    handleRightResize,
  }
}

export default useResizeHandlers
